module.exports = __webpack_public_path__ + "img/hdjjTitleBg2.c09d3558.png";